import actionTypes from 'constants/actionTypes'
import filter from 'lodash/filter'


interface AuthErrorState {
  login?: string[] | undefined
  signup?: string[] | undefined
  resetPassword?: string[] | undefined
}

interface AuthErrorAction {
  type?: string
  payload?: {
    idx?: number
  }
  error?: {
    response?: {
      data?: {
        message?: string
      }
    }
  }
}

const addMessage = (messages: string[] | undefined, action: AuthErrorAction): string[] | undefined => {
  const message = action.error?.response?.data?.message
  if (!message) {
    return messages
  }
  return (messages ?? []).concat(message)
}

const single = (state: AuthErrorState = {}, action: AuthErrorAction): AuthErrorState => {
  if (action.type === actionTypes.AUTH.LOGIN.REQUEST) {
    return {}
  }
  if (action.type === actionTypes.AUTH.LOGIN.RECEIVE) {
    return {}
  }
  if (action.type === actionTypes.AUTH.SIGNUP.REQUEST) {
    return {}
  }
  if (action.type === actionTypes.AUTH.SIGNUP.RECEIVE) {
    return {}
  }
  if (action.type === actionTypes.AUTH.RESET_PASSWORD.REQUEST) {
    return {}
  }
  if (action.type === actionTypes.AUTH.RESET_PASSWORD.RECEIVE) {
    return {}
  }
  if (action.type === actionTypes.AUTH.FORGOT_PASSWORD.REQUEST) {
    return {}
  }
  if (action.type === actionTypes.AUTH.FORGOT_PASSWORD.RECEIVE) {
    return {}
  }
  if (action.type === actionTypes.AUTH.LOGIN.FAIL) {
    return {
      login: addMessage(state.login, action),
    }
  }
  if (action.type === actionTypes.AUTH.FORGOT_PASSWORD.FAIL) {
    return {
      login: addMessage(state.login, action),
    }
  }
  if (action.type === actionTypes.AUTH.SIGNUP.FAIL) {
    return {
      signup: addMessage(state.signup, action),
    }
  }
  if (action.type === actionTypes.AUTH.RESET_PASSWORD.FAIL) {
    return {
      resetPassword: addMessage(state.resetPassword, action),
    }
  }
  if (action.type === actionTypes.AUTH.LOGIN.DISMISS_ERROR) {
    return {
      login: filter(state.login, (_message: string, idx: number) => idx !== action.payload?.idx),
    }
  }
  if (action.type === actionTypes.AUTH.SIGNUP.DISMISS_ERROR) {
    return {
      signup: filter(state.signup, (_message: string, idx: number) => idx !== action.payload?.idx),
    }
  }
  if (action.type === actionTypes.AUTH.RESET_PASSWORD.DISMISS_ERROR) {
    return {
      resetPassword: filter(state.resetPassword, (_message: string, idx: number) => idx !== action.payload?.idx),
    }
  }
  return state
}

export default single
